(function () {
  /* ── Equal-height cards ─────────────────────────────────────────────── */
  /*
    CSS (card-size-picker.css) handles equal-height buttons via flexbox:
    .m-product-item { display:flex } → card stretches to row height
    .m-product-card__content { flex:1 } + .m-card-footer { margin-top:auto }
    pins the button to the bottom of every card in the row.

    No JS height manipulation needed. We only watch lazy images to ensure
    the browser recomputes layout after image dimensions are known.
  */
  function watchImages() {
    var grid = document.querySelector('.m-collection-products');
    if (!grid) return;
    grid.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        // Force a sync reflow so the browser recalculates flex heights
        void grid.offsetHeight;
      }, { once: true });
    });
  }

  window.addEventListener('load', watchImages);

  document.addEventListener('collection:products-loaded', watchImages);
  document.addEventListener('collection:productsLoaded', watchImages);

  /* ── Sheet state ────────────────────────────────────────────────────── */
  var sheet = null;
  var currentVariantId = null;

  function getSheet() {
    if (!sheet) sheet = document.getElementById('m-size-sheet');
    return sheet;
  }

  function openSheet(productId, stockCount) {
    var s = getSheet();
    if (!s) return;

    var tpl = document.getElementById('PickerData-' + productId);
    if (!tpl) return;

    // Populate options
    var optionsEl = s.querySelector('.m-size-sheet__options');
    optionsEl.innerHTML = '';
    optionsEl.appendChild(tpl.content.cloneNode(true));

    // Stock message
    var stockEl = s.querySelector('.m-size-sheet__stock');
    var stock = parseInt(stockCount, 10);
    if (stock > 0 && stock <= 10) {
      stockEl.textContent = 'Restam ' + stock + ' itens!';
      stockEl.removeAttribute('hidden');
    } else {
      stockEl.setAttribute('hidden', '');
    }

    // Reset state
    currentVariantId = null;
    s.setAttribute('data-product-id', productId);
    var atcBtn = s.querySelector('.m-size-sheet__atc');
    atcBtn.disabled = true;
    atcBtn.textContent = 'Adicionar ao carrinho';

    s.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    var s = getSheet();
    if (!s) return;
    s.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    currentVariantId = null;
  }

  document.addEventListener('click', function (e) {
    // Open sheet
    var openBtn = e.target.closest('[data-open-size-picker]');
    if (openBtn) {
      openSheet(
        openBtn.getAttribute('data-open-size-picker'),
        openBtn.getAttribute('data-stock') || '0'
      );
      return;
    }

    var s = getSheet();
    if (!s) return;

    // Close via backdrop or close button
    if (e.target.closest('.m-size-sheet__close') || e.target.classList.contains('m-size-sheet__backdrop')) {
      closeSheet();
      return;
    }

    // Select option
    var opt = e.target.closest('.m-sheet-option');
    if (opt && !opt.disabled) {
      s.querySelectorAll('.m-sheet-option').forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      currentVariantId = opt.getAttribute('data-variant-id');
      s.querySelector('.m-size-sheet__atc').disabled = false;
      return;
    }
  });

  // Handle "Adicionar ao carrinho" in sheet
  document.addEventListener('click', function (e) {
    var s = getSheet();
    if (!s) return;
    var atcBtn = e.target.closest('.m-size-sheet__atc');
    if (!atcBtn || atcBtn.disabled || !currentVariantId) return;

    atcBtn.disabled = true;
    atcBtn.textContent = 'Adicionando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(currentVariantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        closeSheet();
        // Trigger theme cart update events
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
        document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: data }));
        // Open cart drawer if the theme supports it
        document.dispatchEvent(new CustomEvent('open-cart-drawer', { bubbles: true }));
      })
      .catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Adicionar ao carrinho';
      });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });
})();
